import { IconAdjustmentsBolt, IconContainer, IconReceipt, IconReport, IconTruck } from '@tabler/icons-react';

export type Role = 'User' | 'Admin' | 'SuperAdmin' | 'Hr' | 'Driver';
export type Category = 'CLIENT' | 'VENDOR' | 'TRAILER';

export interface RouteAccess {
    path: string;
    label: string;
    showInMenu: boolean;
    icon?: React.ElementType;
    navGroup?: string;
    canAccess: (role: Role, category: Category) => boolean;
    data?: unknown;
}

export const ROUTE_CONFIG: RouteAccess[] = [
    {
        path: '/',
        label: 'Home',
        canAccess: () => true,
        showInMenu: false,
    },
    {
        path: '/dashboard',
        label: 'Dashboard',
        icon: IconReport,
        navGroup: 'Overview',
        showInMenu: true,
        canAccess: (role, category) =>
            ['User', 'Admin', 'SuperAdmin'].includes(role) &&
            ['CLIENT', 'VENDOR'].includes(category),
    },
    {
        path: '/scanner',
        label: 'Scan',
        navGroup: 'Trailer',
        icon: IconContainer,
        showInMenu: true,
        canAccess: (role, category) =>
            (role === 'User' && category === 'TRAILER') ||
            ((role === 'User' || role === 'SuperAdmin') && category === 'CLIENT'),
    },
    {
        path: '/trailer',
        label: 'Products',
        navGroup: 'Trailer',
        icon: IconContainer,
        showInMenu: true,
        canAccess: (role, category) =>
            ['User', 'SuperAdmin'].includes(role) && category === 'CLIENT',
    },
    // {
    //     path: '/driverBol',
    //     label: 'Driver Bol',
    //     navGroup: 'BOL',
    //     icon: IconTruck,
    //     showInMenu: true,
    //     canAccess: (role, category) =>
    //         ['Driver', 'SuperAdmin'].includes(role) && category === 'CLIENT',
    // },
    {
        path: '/yard',
        label: 'Map',
        navGroup: 'Trailer',
        icon: IconContainer,
        showInMenu: true,
        canAccess: (role, category) =>
            ['User', 'SuperAdmin'].includes(role) && category === 'CLIENT',
    },
    {
        path: '/bol',
        label: 'SVP DC',
        navGroup: 'BOL',
        icon: IconTruck,
        showInMenu: true,
        canAccess: (role, category) =>
            ['User', 'SuperAdmin'].includes(role) && category === 'CLIENT',
    },
    {
        path: '/shunting',
        label: 'SHUNTING',
        navGroup: 'SHUNTING',
        icon: IconAdjustmentsBolt,
        showInMenu: true,
        canAccess: (role, category) =>
            ['User', 'Admin', 'SuperAdmin'].includes(role) && (category === 'CLIENT' || category === 'VENDOR'),
    },
    {
        path: '/approvals',
        label: 'APPROVALS',
        navGroup: 'BOL',
        icon: IconTruck,
        showInMenu: true,
        canAccess: (role, category) =>
            ['User', 'SuperAdmin'].includes(role) && category === 'CLIENT',
    },
    {
        path: '/bolList',
        label: 'G2000',
        navGroup: 'BOL',
        icon: IconTruck,
        showInMenu: true,
        canAccess: (role, category) => {
            if (role === 'SuperAdmin') return category === 'CLIENT';
            return role === 'Admin' && category === 'VENDOR';
        },
    },
    {
        path: '/supplyBilling',
        label: 'Supply Billing',
        navGroup: 'Billing',
        icon: IconReceipt,
        showInMenu: true,
        canAccess: (role, category) =>
            ['User', 'SuperAdmin'].includes(role) && category === 'CLIENT',
    },
    {
        path: '/superAdminBol',
        label: 'Head Office',
        navGroup: 'BOL-Billing',
        icon: IconTruck,
        showInMenu: true,
        canAccess: (role, category) =>
            ['Admin', 'SuperAdmin'].includes(role) && category === 'CLIENT',
    },
    {
        path: '/users',
        label: 'Users',
        navGroup: 'Admin',
        icon: IconReport,
        showInMenu: true,
        canAccess: (role, category) =>
            role === 'SuperAdmin' && category === 'CLIENT',
    },
    {
        path: '/register',
        label: 'Register',
        navGroup: 'Admin',
        icon: IconReport,
        showInMenu: true,
        canAccess: (role, category) =>
            role === 'SuperAdmin' && category === 'CLIENT',
    },
    {
        path: '/stores',
        label: 'Stores',
        navGroup: 'Admin',
        icon: IconReport,
        showInMenu: true,
        canAccess: (role, category) =>
            role === 'SuperAdmin' && category === 'CLIENT',
    },
];